module.exports = __webpack_public_path__ + "img/individuelles_reparaturen.dd47b0b3.jpg";